import React, { useRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';

import { setMobileSidebarState } from '../../redux/layout/layoutActions';
import useClickOutside from '../../../../hooks/useClickOutside';
import useBodyClass from '../../../../hooks/useBodyClass';

const propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

const Sidebar = ({ children, className }) => {
  const ref = useRef();
  const dispatch = useDispatch();
  const onMobileSidebarCollapse = useCallback(
    () => dispatch(setMobileSidebarState(false)),
    [],
  );
  const { mobileSidebarExpanded } = useSelector(state => state.pro.layout);
  const classes = classNames({
    'pro-wrapper-sidebar': true,
    'is-open': mobileSidebarExpanded,
    [className]: !!className,
  });

  useClickOutside(ref, () => {
    if (mobileSidebarExpanded) {
      onMobileSidebarCollapse();
    }
  });

  useBodyClass('body-mobile-pro-panels-open', mobileSidebarExpanded);

  return (
    <div className={classes} ref={ref}>
      <div className="pro-wrapper-sidebar-wrap">{children}</div>
    </div>
  );
};

Sidebar.propTypes = propTypes;

export default Sidebar;
